import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import sortBy from "lodash/sortBy";
import { useSnackbar } from "notistack";
import type { LoyaltyPointConfigResponse, UpdateLoyaltyPointConfigRequest } from "./loyaltyApi";
import { listLoyaltyPointConfigs, updateLoyaltyPointConfig } from "./loyaltyApi";

const loyaltyPointConfigsKey = "loyalty-point-configs";

export const useLoyaltyPointConfigs = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const { data, isLoading } = useQuery({
    queryKey: [loyaltyPointConfigsKey],
    queryFn: ({ signal }) => listLoyaltyPointConfigs(signal),
  });

  const updateMutation = useMutation<LoyaltyPointConfigResponse, unknown, UpdateLoyaltyPointConfigRequest>({
    mutationFn: (request) => updateLoyaltyPointConfig(request),
    onSuccess: async () => {
      enqueueSnackbar(`Konfiguracja punktów została zmieniona`, { variant: "success" });
      await queryClient.invalidateQueries({ queryKey: [loyaltyPointConfigsKey] });
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się zmienić ilości punktów. Powód: ${(error as Error).message}`, {
        variant: "error",
      });
    },
  });

  return {
    loyaltyPointConfigs: sortBy(data ?? [], ({ action }) => action.trim().toLowerCase()),
    isLoading,
    updateLoyaltyPointConfig: (request: UpdateLoyaltyPointConfigRequest) => updateMutation.mutateAsync(request),
  };
};
